/**
 * Asynchronously loads natural image dimensions from a URL.
 * Resolves to null if the image fails to load.
 */
export function loadImageNaturalSize(
  url: string
): Promise<{ width: number; height: number } | null> {
  return new Promise((resolve) => {
    const img = new Image()

    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = () => resolve(null)
    img.src = url
  })
}
